function isValidMailAddress(email) {
  if (email.match(/^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[A-Z0-9-]+\.)+[A-Z]{2,6}$/i)) {
    return true;
  }

  return false;
}

module.exports = {
  isValidMailAddress
};
